import lightFormat from 'date-fns/lightFormat';
import { plural as pluralize } from '@cian/utils';

import { IServicePackage, EServiceId } from '../../../../../../../../redux/reducers';

import { DATE_PATTERN, PACKAGE_NAMES } from './constants';

export const formatPackageOptionLabel = ({
  servicePackageEndDate: endDate,
  servicePackageActualCount: count,
  serviceId,
}: IServicePackage): string => {
  const singleAvailableWord =
    serviceId === EServiceId.top || serviceId === EServiceId.premium ? 'Доступен' : 'Доступна';

  const availableWord = pluralize(count, [singleAvailableWord, 'Доступно', 'Доступно']);

  const { single, plural, pluralSecondForm } = PACKAGE_NAMES[serviceId];
  const packageName = pluralize(count, [single, plural, pluralSecondForm]);

  const formattedEndDate = lightFormat(new Date(endDate), DATE_PATTERN);

  return count > 1
    ? `(${availableWord} ${count} ${packageName} до ${formattedEndDate})`
    : `(${singleAvailableWord} ${single} до ${formattedEndDate})`;
};
